import './polyfill'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/alert'
import './plugins/event-bus'
import vuetify from './plugins/vuetify'

import GSignInButton from 'vue-google-signin-button'

Vue.use(GSignInButton)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
